export const integrations = {
  statuses: {
    connected: 'Terhubung'
  },
  timepicker: 'Jam dan menit',
  menu: {
    title: 'Integrasi',
    v1: 'List',
    settings: 'Settings'
  },
  breadcrumb: {
    title: 'Integrasi',
    settings: {
      index: 'Pengaturan CRM'
    },
    auth: {
      index: 'Otorisasi'
    },
    users: {
      index: 'Pengguna CRM'
    },
    cases: {
      index: 'Panggilan masuk'
    },
    numbers: {
      index: 'Nomor'
    }
  },
  tabs: {
    auth: 'Login',
    cases: 'Panggilan masuk',
    users: 'Pengguna',
    numbers: 'Nomor'
  },
  button: {
    sync_users: 'Sinkronisasi pengguna'
  },
  modal: {
    edit: 'Edit pengguna'
  },
  users_status_default: 'Dapat dikonfigurasi. Panggilan tidak tersedia',
  users_status: {
    enabled: 'Panggilan tersedia',
    disabled: 'Dimatikan. Panggilan tidak tersedia'
  },
  page: {
    amo_info: 'Sistem CRM online. Manajemen pelanggan dalam CRM cloud modern — amoCRM.',
    kommo_info:
      'Kommo dilengkapi dengan 8 instrumen utama yang memberdayakan karyawan Anda untuk menjual dengan lebih efektif.',
    connect: 'Terhubung:',
    tooltip: {
      other_integration: 'Anda sudah memiliki integrasi lain yang terhubung.'
    },
    button: {
      connect: 'Menghubung',
      loading: 'Login...',
      settings: 'Pengaturan',
      not_connected: 'Widget CRM tidak terhubung'
    },
    no_integration: 'Tidak ada integrasi'
  },
  users_table: {
    tech_status: 'Status teknis',
    amo_name: 'Nama di CRM',
    amo_login: 'Login di CRM',
    amo_id: 'ID di CRM',
    sip_account: 'Detail akun SIP',
    sip_password: 'Kata sandi akun SIP',
    caller_id: 'Caller ID',
    inner_number: 'Nomor masuk',
    queue_name: 'Berada dalam antrian',
    queue: 'Antre'
  },
  settings: {
    request_info1: 'Kami telah menerima aplikasi Anda untuk mengaktifkan integrasi dengan CRM!',
    request_info2:
      'Spesialis teknis sudah menyiapkan jalur masuk dan keluar untuk anda. Untuk sepenuhnya menggunakan telepon, Anda perlu memilih dan menghubungkan nomor virtual. Kami akan segera menghubungi Anda untuk ini.',
    account: {
      title: 'Akun',
      description: '',
      settings: {
        main: {
          title: 'Dasar',
          description: '',
          children: {
            domain: {
              title: 'Domain',
              description: 'Domain salinan CRM yang terhubung ke akun Zorra saat ini'
            },
            amo_login: {
              title: 'Login',
              description: 'Login akun CRM yang terhubung ke akun Zorra saat ini'
            },
            status: {
              title: 'Status',
              description: ''
            },
            integration: {
              title: 'Integrasi'
            }
          }
        }
      }
    },
    integration_scenarios: {
      create_deal: 'Buat kesepakatan',
      create_task: 'Buat tugas',
      create_contact: 'Buat kontak',
      create_note: 'Buat catatan',
      tooltip_contact: 'Kontak akan dibuat di CRM dengan nomor klien panggilan.',
      tooltip_deal2: 'Transaksi akan dibuat di CRM dengan nomor penelepon.',
      create_deal_unsorted: 'Buat kesepakatan di "Tidak disortir"',
      tooltip_deal_unsorted:
        'Di CRM, kesepakatan dengan nomor klien yang menelepon akan dibuat pada tahap "Belum diuraikan".',
      tooltip_task:
        'Jika karyawan Anda tidak menjawab panggilan, tugas dengan nomor yang terlewat akan dibuat.',
      tooltip_time: 'Atur waktu penyelesaian tugas dalam jam dan menit. ',

      tooltip_deal:
        'Jika ada kontak dan dia tidak memiliki kesepakatan terbuka, kesepakatan baru akan dibuat.',

      tooltip_deal3: 'Transaksi akan dibuat di CRM dengan nomor telepon yang dihubungi.',
      tooltip_note:
        'Untuk panggilan keluar, jika pelanggan belum menjawab, sebuah catatan akan dibuat:" tidak dapat mencapai +71234567890."',
      tooltip_outgoing_contact: 'Kontak dengan nomor klien panggilan akan dibuat di CRM.',
      open_contact: 'Buka kontak',
      tooltip_open_contact:
        'Dengan panggilan masuk dari nomor mana pun, kartu kontak akan terbuka di tab baru.',
      incoming: {
        title: 'Panggilan masuk',
        known: 'Nomor yang diketahui',
        unknown: 'Nomor tidak dikenal',
        missed: 'Panggilan tidak terjawab',
        deadline_task: 'Batas waktu tugas',
        any_call: 'Panggilan apa saja'
      },
      outgoing: {
        title: 'Panggilan keluar',
        known: 'Nomor yang diketahui',
        unknown: 'Nomor tidak dikenal',
        not_answered: 'Panggilan tidak dijawab'
      }
    },
    users: {
      title: 'Pengguna',
      description: '',
      settings: []
    },
    webhooks: {
      title: 'Webhooks',
      description: '',
      settings: []
    },
    additional: {
      title: 'Pengaturan tambahan',
      description: '',
      settings: []
    }
  }
};
